import React, {JSX} from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface NotAuthRouteProps {
    element: JSX.Element;
}

const NotAuthRoute: React.FC<NotAuthRouteProps> = ({ element }) => {
    const { loading } = useAuth();

    if (loading) {
        return (
            <div style={{ height: "90vh", paddingTop: 100 }}>
                <div className="spinner-wrapper">
                    <div className="spinner"></div>
                </div>
            </div>
        );
    }

    return element;
};

export default NotAuthRoute;
